module.exports = __webpack_public_path__ + "796c16e52fe28210d935ac38359ecb42.png";